import React, { useState } from 'react'
import { Nav, Input, InputGroup } from 'rsuite'
import PlusIcon from '@rsuite/icons/Plus'
import { Search } from '@rsuite/icons'
import { Button } from '../../atoms'
import './toolbar.scss'

interface Props {
  options: { label: string, value: string, onClick: () => void }[];
  buttonName: string;
  onButtonClick: () => void;
  total: number;
  onSearchChange: (value: string) => void;
  showButton?: boolean;
  rightExtra?: React.ReactNode;
}

const Toolbar: React.FC<Props> = ({
  options,
  buttonName,
  onButtonClick,
  total,
  onSearchChange,
  showButton = true,
  rightExtra
}) => {
  const [active, setActive] = useState(options[0]?.value)

  const onNavSelect = (
    activeKey: string,
    option: { label: string, value: string, onClick: () => void }
  ) => {
    setActive(activeKey)
    option.onClick()
  }

  return (
    <div className="toolbar">
      <div className="toolbar-left">
        {options.length > 0 && (
          <Nav
            appearance="subtle"
            activeKey={active}
            style={{ marginRight: 10 }}
          >
            {options.map((option) => (
              <Nav.Item
                key={option.value}
                role="tab"
                eventKey={option.value}
                onClick={() => onNavSelect(option.value, option)}
              >
                {option.label}
              </Nav.Item>
            ))}
          </Nav>
        )}
        <div className="toolbar-totals">
          <span>Total: {total}</span>
        </div>
      </div>
      <div className="toolbar-right-pane">
        {rightExtra}
        <div>
          <InputGroup size="md" style={{ width: 300, margin: 10 }}>
            <InputGroup.Addon>
              <Search />
            </InputGroup.Addon>
            <Input
              placeholder="Search..."
              role="search"
              onChange={(value: string) => onSearchChange(value)}
            />
          </InputGroup>
        </div>

        {showButton && (
          <Button
            className="toolbar-btn"
            appearance="primary"
            startIcon={<PlusIcon />}
            onClick={onButtonClick}
          >
            {buttonName}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Toolbar
